import '../styles/style.scss';
import { v4 as uuidv4 } from "uuid";
import { useLocation } from 'react-router-dom';
import { useStoreCtx } from '../store';
import SwiperCore, { Autoplay } from 'swiper';
import 'swiper/css';
import { useEffect, useState } from 'react';
import { getClientID } from '../util/helpers';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { tvhEnvironmentApi } from "../util/HashParser";
import { SHELVES_ITEM_LINK } from '../util/interfaces';
import { Subscription } from '../util/promo';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Autoplay]);

export const IndexView = observer(() => {
	const httpService = useStoreCtx().appStore
	const sessionId = uuidv4()
	const location = useLocation()

	// Прокрутка к шапке
	useEffect(() => {
		setTimeout(() => window.scrollTo(0, 0))
	}, []);

	useEffect(() => {
		httpService.clearSessionSaveOldValues(
			window.sessionStorage.getItem("request_id"),
			window.sessionStorage.getItem("analyticsQuery"),
			window.sessionStorage.getItem("subscription_period"),
		)
		if (location.pathname === '/') {
			const intervalId = setInterval(() => {
				if (getClientID()) {
					clearInterval(intervalId)
					httpService.pushEvent({ event_name: 'screen_show' })
				}
			}, 500)
		} else if (location.pathname === '/ssoauth') {
			const intervalId = setInterval(() => {
				if (httpService.grclientid) {
					clearInterval(intervalId)
					httpService.pushEvent({ event_name: 'screen_show' })
				}
			}, 500)
		}
	}, []);

	function webSsoAuth(subscription?: Subscription) {
		if (!subscription) {
			window.sessionStorage.removeItem("subscription_period")
		} else {
			httpService.selectedSubscription = subscription;
			window.sessionStorage.setItem("subscription_period", subscription.promotion.timeToLiveValue.toString())
		}
		window.sessionStorage.setItem("request_id", uuidv4())
		httpService.pushEvent({
			event: 'authorization_start',
			event_name: 'authorization_start',
			referer: '',
			auth_method: "sms",
			auth_type: 'websso',
			request_id: window.sessionStorage.getItem("request_id")
		})

		const hostUrl = window.location.host
		window.location.assign(
			encodeURI(
				`https://${tvhEnvironmentApi}/tvh-public-api-gateway/public/rest/general/websso/redirect?state=${sessionId}&clientType=WEB&domain=${hostUrl}`
			)
		);
	};

	const [data, setData] = useState<{ img: string; link: string; }[]>([]);
	const postersFirst = data.filter((_, idx) => idx <= data.length / 2) || [];
	const postersSecond = data.filter((_, idx) => idx > data.length / 2) || [];

	async function getData() {
		await httpService.getImgsForSwapper().then((response) => {
			const posters = response.data.items.filter(item => item.imageUrl.startsWith('http')).map(item => {
				let link = '';
				if (item.link.linkType === SHELVES_ITEM_LINK.MOVIE) {
					link = "https://kion.ru/video/movie/" + item.link.movieContentId;
				} else {
					link = "https://kion.ru/video/serial/" + item.link.seriesContentId;
				}

				return { img: item.imageUrl, link: link }
			})
			setData(posters)
		})
	}

	useEffect(() => {
		getData()
	}, []);

	function htmlTile1() {
		return { __html: '<div>Премьеры <p style="display: inline-block">от KION Originals</p></div>' };
	};

	function htmlTile2() {
		return { __html: '<div>Более 200 ТВ каналов</div>' };
	};

	function htmlTile3() {
		return { __html: '<div>Скачивай кино <p style="display: inline-block">в дорогу</p></div>' };
	};

	function htmlTile4() {
		return { __html: '<div>Подписка <p style="display: inline-block">для всей семьи</p></div>' };
	};

	function htmlTile5() {
		return { __html: '<div>Безопасный детский профиль</div>' };
	};

	function htmlTile6() {
		return { __html: '<div>Привилегии МТС Premium</div>' };
	};

	function childProfileImage() {
		if (window.innerWidth > 998) {
			return 'images/subscription-block/child-profile-2x.png';
		} else {
			return 'images/subscription-block/child-profile-2x-mobile.png'
		}
	};

	const subscriptionList = [
		{
			img: 'images/subscription-block/kion-originals-2x.png',
			title: htmlTile1(),
			description: 'Жизнь по вызову, Первый номер, Амура, Почка, Хрустальный и др.',
			className: "tile1"
		},
		{
			img: 'images/subscription-block/channels-2x.png',
			title: htmlTile2(),
			description: 'Работает дома, на даче, в пути — везде, где есть интернет',
			className: "tile2"
		},
		{
			img: 'images/subscription-block/kino-v-dorogu-2x.png',
			title: htmlTile3(),
			description: 'Возможность сохранять любимое кино и смотреть офлайн',
			className: "tile3"
		},
		{
			img: 'images/subscription-block/devices-2x.png',
			title: htmlTile4(),
			description: 'Подключай до 5 устройств',
			className: "tile4"
		},
		{
			img: childProfileImage(),
			title: htmlTile5(),
			description: 'Контент для детей с возможностью родительского контроля',
			className: "tile5"
		},
		{
			img: 'images/subscription-block/premium.png',
			title: htmlTile6(),
			description: 'Все преимущества подписки МТС Premium',
			className: "tile6"
		},
	];

	const letoSliderImages = [
		{
			image: "images/leto-slider/1-dorogoy-rodstvennik.png",
			url: "https://kion.ru/serial/dorogoj-rodstvennik",
		},
		{
			image: "images/leto-slider/2-vinograd.png",
			url: "https://kion.ru/serial/vinograd",
		},
		{
			image: "images/leto-slider/3-nereality1.png",
			url: "https://kion.ru/serial/nerealiti",
		},
		{
			image: "images/leto-slider/4-pochka.png",
			url: "https://kion.ru/serial/pochka",
		},
		{
			image: "images/leto-slider/5-nereality2.png",
			url: "https://kion.ru/serial/nerealiti",
		},
		{
			image: "images/leto-slider/6-uspeschniy.png",
			url: "https://kion.ru/serial/uspeshnyj",
		},
		{
			image: "images/leto-slider/7-teatralnaya-zona.png",
			url: "https://kion.ru/", // TODO: link to serial kion
		},
		{
			image: "images/leto-slider/8-tri-sestry.png",
			url: "https://kion.ru/serial/tri-sestry",
		},
	];

	useEffect(() => {
		if (location.search) window.sessionStorage.setItem("analyticsQuery", JSON.stringify(location.search))
	}, []);

	const [isVisibleHeader, setIsVisibleHeader] = useState<boolean>(false);

	useEffect(() => {
		const fullScreenBlockId = document.getElementById("fullScreenBlockId");

		const observer = new IntersectionObserver(([entry]) => {
			if (entry.target.id === "fullScreenBlockId") setIsVisibleHeader(!entry.isIntersecting);
		}, {
			threshold: 0,
		});

		if (fullScreenBlockId) observer.observe(fullScreenBlockId);

		return () => {
			if (fullScreenBlockId) observer.unobserve(fullScreenBlockId);
		};
	}, [data]);

	return (
		<div className="global_wrapper">
			{isVisibleHeader && (
				<header className="header">
					<div className="wrapper">
						<a className="logo" href="https://kion.ru/">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width={`${window.innerWidth <= 598 ? 85 : (window.innerWidth > 998 ? '137.993' : '101')}`}
								height={`${window.innerWidth <= 598 ? 27 : (window.innerWidth > 998 ? '44' : '33')}`}
								viewBox="0 0 137.993 44"
							>
								<path
									d="M131.183,40.952c0-2.309,1.286-3.067,3.451-3.067,1.993,0,3.183.559,3.353,2.155h-1.622c-.141-.751-.72-.924-1.731-.924-1.076,0-1.837.273-1.837,1.5v.672c0,1.192.734,1.49,1.844,1.49.956,0,1.562-.173,1.73-.871h1.622c-.188,1.517-1.38,2.1-3.359,2.1C132.469,44,131.183,43.261,131.183,40.952Zm-58.819-.046c0-2.336,1.318-3.021,3.7-3.021s3.7.739,3.7,3.021-1.319,3.088-3.7,3.088S72.365,43.241,72.365,40.906Zm1.615-.286v.618c0,1.185.707,1.531,2.086,1.531s2.073-.339,2.073-1.531V40.62c0-1.125-.7-1.5-2.073-1.5S73.979,39.5,73.979,40.62ZM0,40.912c0-2.282,1.319-3.021,3.7-3.021v-.006c2.382,0,3.7.739,3.7,3.021s-1.319,3.088-3.7,3.088S0,43.248,0,40.912Zm1.615-.292v.618c0,1.185.706,1.531,2.086,1.531s2.073-.339,2.073-1.531V40.62c0-1.125-.7-1.5-2.073-1.5S1.615,39.5,1.615,40.62Zm125.3,3.261V39.289h-2.4V38h6.413v1.284h-2.409V43.88Zm-4.777,0V39.322l-1.548,4.559h-1.749l-1.548-4.539V43.88h-1.467V38h2.523l1.474,4.386L121.3,38h2.435V43.88Zm-15.114,0V38h4.044c1.474,0,2.147.739,2.147,2a1.871,1.871,0,0,1-2.147,2.036h-2.442V43.88Zm1.6-3.068h2.22c.525,0,.747-.273.747-.679V39.9c0-.386-.222-.672-.747-.672h-2.22Zm-6.386,3.068V39.289h-2.4V38h6.412v1.284h-2.409V43.88Zm-3.27,0L98.4,42.569H95.358L94.8,43.88H93.292L95.869,38h2.2l2.558,5.876Zm-3.11-2.462H97.9l-1.022-2.376ZM82.68,43.88V39.289h-2.4V38h6.413v1.284H84.281V43.88Zm-12.88,0V41.512H66.638V43.88h-1.6V38h1.6v2.223H69.8V38h1.6V43.88Zm-7.59,0V39.947l-3.2,3.933H57.291V38h1.6v3.933L62.089,38h1.723V43.88Zm-7.53,0-2.228-2.369h-.645V43.88h-1.6V38h1.6v2.223h.7L54.667,38h1.885l-2.705,2.8,2.867,3.074Zm-11.4,0V41.512H40.118V43.88h-1.6V38h1.6v2.223h3.164V38h1.6V43.88Zm-7.591,0V39.947l-3.2,3.933H30.772V38h1.6v3.933L35.57,38h1.723V43.88Zm-7.227,0L27.9,42.569H24.857L24.3,43.88H22.792L25.368,38h2.2l2.557,5.876Zm-3.109-2.462H27.4l-1.022-2.376Zm-4.8,2.462V39.289H18.094V40.44c0,2.535-.4,3.441-2.127,3.441H15.5v-1.4h.209c.768,0,.888-.6.888-2.043V38h5.551V43.88Zm-7.422,0V41.512H9.966V43.88h-1.6V38h1.6v2.223h3.163V38h1.6V43.88Zm74.329-.007V38h5.417v1.224H89.06v1.071h2.9v1.165h-2.9v1.2H92.9v1.218ZM45.98,41.518V40.207H49.1v1.311ZM98.069,38h.007Zm-70.5,0h.007Zm4.448-1.77H33.3c.027.466.249.633.707.633s.686-.16.713-.633h1.285c-.027.985-.653,1.484-2,1.484S32.044,37.226,32.017,36.234ZM127.9,31.277,115.114,15.259V29.946a1.467,1.467,0,0,1-1.345,1.331h-7.4a1.467,1.467,0,0,1-1.346-1.331V1.331A1.467,1.467,0,0,1,106.367,0h8.746L127.9,15.971V1.331A1.467,1.467,0,0,1,129.245,0h7.4a1.437,1.437,0,0,1,1.346,1.3V29.879a1.534,1.534,0,0,1-1.346,1.4Zm-77.378,0a1.365,1.365,0,0,1-1.346-1.331V1.331A1.365,1.365,0,0,1,50.522,0H99.644a1.365,1.365,0,0,1,1.345,1.331V29.946a1.365,1.365,0,0,1-1.345,1.331ZM59.27,8.651V21.96c0,.692.418.7.673.665,2.584-.373,9.124-.285,15.323-.273,1.328,0,2.66,0,3.958,0,4.693,0,8.944-.006,11,.244.249.026.673.026.673-.665V8.644c0-.666-.41-.712-.673-.659-2.651.518-8.808.645-14.958.659-5.936.014-12.281-.074-15.323-.659a.788.788,0,0,0-.141-.013C59.558,7.973,59.27,8.1,59.27,8.651ZM36.3,31.277a1.426,1.426,0,0,1-1.265-1.331V1.331A1.426,1.426,0,0,1,36.3,0h7.57a1.426,1.426,0,0,1,1.265,1.331V29.946a1.426,1.426,0,0,1-1.265,1.331Zm-14.044,0a1.679,1.679,0,0,1-1.346-.666l-6.056-10.7H10.14V29.946a1.467,1.467,0,0,1-1.345,1.331h-7.4A1.468,1.468,0,0,1,.047,29.946V1.3A1.426,1.426,0,0,1,1.393,0h7.4A1.484,1.484,0,0,1,10.14,1.331v9.935h4.038L20.235.665A1.736,1.736,0,0,1,21.58,0H31a.822.822,0,0,1,.673,1.331L22.926,15.259l8.748,14.687A.84.84,0,0,1,31,31.277Z"
									fill="#fff"
								/>
							</svg>
						</a>
						{window.innerWidth > 768 && (
							<div className={clsx("btn")} onClick={() => webSsoAuth()}>
								Оформить подписку
							</div>
						)}
					</div>
				</header>
			)}

			<div className="f_screen" id="fullScreenBlockId">
				<div className={clsx("wrapper", "fullWWrapper")}>
					<img src="images/background.png" />
					<div className="wrapper-main">
						<div className="info">
							{window.innerWidth > 768 && (
								<a className="logo" href="https://kion.ru/">
									<svg width="346" height="114" viewBox="0 0 346 114" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M109.649 79.2837C111.512 79.2837 113.021 77.7737 113.021 75.9104C113.021 51.9461 113.021 27.3376 113.021 3.37326C113.021 1.50997 111.511 0 109.647 0H91.0918C89.2285 0 87.7181 1.50828 87.718 3.37154C87.7177 26.6996 87.7178 52.584 87.7178 75.9121C87.7178 77.7754 89.2267 79.2837 91.09 79.2837C96.8975 79.2837 103.841 79.2837 109.649 79.2837Z" fill="white" />
										<path d="M21.9296 79.2837C23.7929 79.2837 25.3034 77.7732 25.3034 75.9099V50.4717H37.1116L52.2936 77.5968C52.6984 78.2547 53.9805 79.2837 55.6674 79.2837H77.5969C79.3513 79.2837 80.1947 77.3775 79.2838 75.9099L57.3543 38.6803L79.2838 3.37377C80.3128 1.90618 79.4019 0 77.5969 0H53.9805C52.2936 0 51.0116 1.07961 50.6067 1.68689L35.4247 28.559H25.3034C25.3034 20.1907 25.1618 11.8091 25.2522 3.43894C25.2726 1.55036 23.7528 0 21.8641 0H3.37386C1.51059 0 9.94347e-05 1.51047 8.42235e-05 3.37374C-0.000113165 27.5525 9.82936e-05 51.7312 9.82936e-05 75.9099C9.82936e-05 77.7732 1.51059 79.2837 3.37387 79.2837C9.55912 79.2837 15.7444 79.2837 21.9296 79.2837Z" fill="white" />
										<path d="M342.438 79.2837C344.301 79.2837 345.812 77.7732 345.812 75.9099C345.812 51.7311 345.815 27.5522 345.812 3.37333C345.812 1.51022 344.301 1.28699e-05 342.438 1.28699e-05H323.882C322.019 1.28699e-05 320.508 1.51045 320.508 3.3737C320.508 15.7442 320.508 28.1148 320.508 40.4853L288.458 8.21407e-06C281.148 8.21407e-06 273.838 -8.14079e-06 266.528 5.30473e-06C264.665 8.73199e-06 263.154 1.5105 263.154 3.37378C263.154 27.5525 263.154 51.7313 263.154 75.91C263.154 77.7733 264.665 79.2837 266.528 79.2837H285.084C286.947 79.2837 288.458 77.7731 288.458 75.9098C288.457 63.5 288.458 51.0902 288.458 38.6803L320.508 79.2837H342.438Z" fill="white" />
										<path d="M123.143 75.9098C123.143 77.7731 124.653 79.2837 126.517 79.2837C167.564 79.2837 208.612 79.2837 249.659 79.2837C251.523 79.2837 253.033 77.7732 253.033 75.9099C253.033 51.7312 253.032 27.5526 253.033 3.37394C253.033 1.51059 251.523 0 249.659 0H126.517C124.653 0 123.143 1.51046 123.143 3.37373C123.143 27.5524 123.143 51.7311 123.143 75.9098ZM150.133 20.2426C157.758 21.7271 173.665 21.9464 188.543 21.9127C203.962 21.8789 219.397 21.5584 226.043 20.2426C226.701 20.1077 227.73 20.2258 227.73 21.9127V55.5998C227.73 57.3542 226.667 57.3542 226.043 57.2867C219.464 56.477 203.911 55.7179 188.543 55.6673C173.176 55.6167 156.611 56.4095 150.133 57.3542C149.492 57.4385 148.446 57.4216 148.446 55.6673V21.9295C148.446 20.2426 149.492 20.1246 150.133 20.2426Z" fill="white" />
										<path d="M9.27471 97.5243C15.2443 97.5243 18.5494 99.3961 18.5494 105.18C18.5494 110.964 15.2443 113.005 9.27471 113.005C3.30517 113.005 0 111.116 0 105.18C0 99.2444 3.30517 97.5243 9.27471 97.5243ZM14.4686 104.455C14.4686 101.605 12.7148 100.644 9.27471 100.644C5.83464 100.644 4.04715 101.622 4.04715 104.455V106.023C4.04715 109.025 5.81777 109.902 9.27471 109.902C12.7316 109.902 14.4686 109.042 14.4686 106.023V104.455ZM24.9743 97.8279V103.46H32.8999V97.8279H36.9133V112.718H32.8999V106.715H24.9743V112.718H20.9608V97.8279H24.9743ZM39.3754 109.177C41.2978 109.177 41.6013 107.659 41.6013 104V97.8279H55.5134V112.718H51.4999V101.082H45.3449V104C45.3449 110.425 44.35 112.718 40.0162 112.718H38.8526V109.177H39.3754ZM69.0882 97.8279L75.4962 112.718H71.331L69.9145 109.396H62.2923L60.8927 112.718H57.1154L63.5739 97.8279H69.105H69.0882ZM63.5402 106.479H68.6666L66.1034 100.459L63.5402 106.479ZM81.432 112.718H77.115V97.8279H81.1284V107.794L89.1384 97.8279H93.4554V112.718H89.4419V102.752L81.432 112.718ZM83.4555 93.3423C83.523 94.5227 84.0795 94.9443 85.2262 94.9443C86.3729 94.9443 86.9462 94.5396 87.0137 93.3423H90.2345C90.1671 95.838 88.5988 97.1028 85.2262 97.1028C81.8535 97.1028 80.3021 95.8549 80.2347 93.3423H83.4555ZM100.538 97.8279V103.46H108.464V97.8279H112.477V112.718H108.464V106.715H100.538V112.718H96.5245V97.8279H100.538ZM123.05 103.41V106.732H115.226V103.41H123.05ZM141.718 97.8279L134.939 104.927L142.122 112.718H137.03L131.448 106.715H129.829V112.718H125.816V97.8279H129.829V103.46H131.583L136.996 97.8279H141.718ZM147.889 112.718H143.573V97.8279H147.586V107.794L155.596 97.8279H159.913V112.718H155.899V102.752L147.889 112.718ZM166.995 97.8279V103.46H174.921V97.8279H178.934V112.718H174.921V106.715H166.995V112.718H162.982V97.8279H166.995ZM190.621 97.5243C196.59 97.5243 199.895 99.3961 199.895 105.18C199.895 110.964 196.59 113.005 190.621 113.005C184.651 113.005 181.346 111.099 181.346 105.18C181.346 99.2612 184.651 97.5243 190.621 97.5243ZM195.814 104.455C195.814 101.605 194.061 100.644 190.621 100.644C187.181 100.644 185.393 101.622 185.393 104.455V106.023C185.393 109.025 187.164 109.902 190.621 109.902C194.078 109.902 195.814 109.042 195.814 106.023V104.455ZM201.177 101.082V97.8279H217.247V101.082H211.21V112.718H207.197V101.082H201.177ZM232.745 100.914H223.183V103.629H230.451V106.58H223.183V109.615H232.812V112.701H219.17V97.811H232.745V100.914ZM245.763 97.8279L252.171 112.718H248.006L246.589 109.396H238.967L237.568 112.718H233.79L240.249 97.8279H245.78H245.763ZM240.215 106.479H245.341L242.778 100.459L240.215 106.479ZM250.181 101.082V97.8279H266.252V101.082H260.215V112.718H256.201V101.082H250.181ZM278.326 97.8279C282.019 97.8279 283.705 99.6997 283.705 102.904C283.705 106.108 282.019 108.064 278.326 108.064H272.204V112.718H268.191V97.8279H278.326ZM279.641 102.634C279.641 101.656 279.085 100.931 277.769 100.931H272.204V104.944H277.769C279.085 104.944 279.641 104.253 279.641 103.224V102.634ZM293.924 101.217V112.718H290.248V97.8279H296.572L300.265 108.941L303.974 97.8279H310.079V112.718H306.065V101.167L302.187 112.718H297.803L293.924 101.217ZM312.018 101.082V97.8279H328.089V101.082H322.052V112.718H318.038V101.082H312.018ZM337.397 97.5243C342.389 97.5243 345.373 98.9408 345.795 102.988H341.731C341.377 101.082 339.927 100.644 337.397 100.644C334.699 100.644 332.794 101.335 332.794 104.438V106.141C332.794 109.16 334.632 109.919 337.414 109.919C339.809 109.919 341.326 109.48 341.748 107.71H345.812C345.34 111.554 342.355 113.022 337.397 113.022C331.967 113.022 328.746 111.15 328.746 105.298C328.746 99.4467 331.967 97.5243 337.397 97.5243Z" fill="white" />
									</svg>
								</a>
							)}
							<h1>Всё лето -50% на подписку*</h1>
							<span>Смотри новинки и хиты сезона за полцены</span>
							{window.innerWidth >= 425 && (
								<div className="white-btn" onClick={() => webSsoAuth()}>
									Оформить подписку
								</div>
							)}
						</div>
						<div className="leto-slider">
							<Swiper
								className="leto-swiper"
								modules={[Autoplay]}
								slidesPerView={'auto'}
								autoplay={{ delay: 2000 }}
								speed={500}
								loop={true}
							>
								{letoSliderImages.map((slide, idx) => (
									<SwiperSlide
										key={idx}
										className="leto-slide"
									>
										<a 
											href={slide.url}
											target="_blank"
											rel="noopener noreferrer"
										>
											<img src={slide.image} />
										</a>
									</SwiperSlide>
								))}
							</Swiper>
						</div>
						{window.innerWidth < 425 && (
							<div className="white-btn" onClick={() => webSsoAuth()}>
								Оформить подписку
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="subscription">
				<div className="wrapper">
					<h1>Что входит в подписку</h1>
					<div className="subscription-block">
						{subscriptionList.map((item) => (
							<div className={`subscription-tile ${item.className}-sub`} key={item.description}>
								<div className={`blackout_circle ${item.className}-bc`}></div>
								<img src={item.img} className={`img-tile ${item.className}-img`} alt={item.description} />
								<div className="tile-content">
									<div className="tile-title" dangerouslySetInnerHTML={item.title} />
									<p className={`desc-tile ${item.className}-desc`}>{item.description}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>

			{data && (
				<>
					<div className="swiper-backdrop"></div>
					<div className="swiper">
						<div className="wrapper">
							<h1>А также мировые хиты</h1>
							<div className="swiper-block">
								<div className="images-content">
									{postersFirst.length && (
										<Swiper
											className="sample-slider"
											modules={[Autoplay]}
											slidesPerView={'auto'}
											autoplay={{ delay: 0 }}
											speed={8000}
											loop={true}
										>
											{postersFirst.map((poster, idx) => (
												<SwiperSlide key={idx} className="img-block">
													<a href={poster.link}>
														<img src={poster.img} />
													</a>
												</SwiperSlide>
											))}
										</Swiper>
									)}

									{postersSecond.length && (
										<Swiper
											className="sample-slider"
											modules={[Autoplay]}
											slidesPerView={'auto'}
											autoplay={{ delay: 0, reverseDirection: true }}
											initialSlide={1}
											speed={8000}
											loop={true}
										>
											{postersSecond.map((poster, idx) => (
												<SwiperSlide key={idx} className="img-block">
													<a href={poster.link}>
														<img src={poster.img} />
													</a>
												</SwiperSlide>
											))}
										</Swiper>
									)}
								</div>
							</div>
						</div>
					</div>
				</>
			)}

			<div className="year-kion">
				<div className="wrapper">
					<div className="yk-block">
						<div className="info_block">
							<div className="title">Больше выгоды с KION</div>
							<div className="desc">Подписка на всё лето со скидкой -50%</div>
							<div
								onClick={() => webSsoAuth()}
								className={clsx("btn")}
							>
								Оформить за полцены
							</div>
						</div>
						{window.innerWidth > 598 ? <img src="images/gifts.png" /> : <img src="images/gifts-mobile.png" />}
						<div className="backdrop"></div>
					</div>
				</div>
			</div>

			<div className="footer">
				<div className="wrapper">
					<div className="text">
						<p>© 2025 ООО «КИОН». Все права защищены. 12+</p>
						<p>
							ООО «КИОН», ОГРН 1197746576060, 127051, Г.МОСКВА, Б-Р ПЕТРОВСКИЙ, Д. 12, СТР.3. ПОМЕЩ. 6, ЭТАЖ 5. Сервис KION 12+
						</p>
						<p>
							*Предложение для подключения действительно для новых пользователей с 01.06.2025 по 31.08.2025, цена подписки составит 199р./мес.
							в течение периода действия предложения для подключения. Со следующего месяца после окончания действия предложения, начиная с 01.09.2025,
							автоматическое продление по цене 399р./мес. Подробности на{" "}
							<a className="footer-link" href="https://kion.ru/subscription/192">
								kion.ru/subscription/192
							</a>
						</p><br />
						<p>
							Материнский инстинкт – © 2023 MINSTINCT INC. ALL RIGHTS RESERVED 18+; Переводчик – © MMXXII EXIT LIGHT PRODUCTIONS LIMITED.
							All Rights Reserved 18+; Достать ножи – © 2019 Lions Gate Films Inc and MRC II Distribution Company LP. All Rights Reserved 18+;
							Ла-Ла Ленд – © 2016 Summit Entertainment, LLC. All Rights Reserved 16+; Операция «Фортуна»: Искусство побеждать – © 2022 MIRAMAX DISTRIBUTION SERVICES,
							LLC. ALL RIGHTS RESERVED 18+; Последний дракон – © 2023 CHINA FILM CORPORATION LTD., GUARDIÁN DE DRAGONES A.I.E., TELEFÓNICA AUDIOVISUAL DIGITAL S.L.U.,
							ATRESMEDIA CINE S.L.U. 6+; Гипнотик – © 2023 Hypnotic Film Holdings LLC. All Rights Reserved 18+; Гнев человеческий - © 2021 FLIC FILMS UK LIMITED ALL RIGHTS RESERVED 18+;
							12 лет рабства – © 2013 Regency Entertainment (USA), Inc. and Bass Films, LLC in the United States. 2013 Bass Films, LLC and Monarchy Enterprises S.a.r.l. in the rest of
							the World. All Rights Reserved 18+; Глубоководный горизонт – © 2016 SUMMIT ENTERTAINMENT, LLC AND PARTICIPANT MEDIA, LLC. ALL RIGHTS RESERVED 18+;
							Судья Дредд – © Rena Films (PTY) Ltd. and Peach Tree Films Ltd 18+; Дивергент – © 2014 SUMMIT ENTERTAINMENT, LLC. ALL RIGHTS RESERVED 16+; Пятый элемент – © Gaumont. Все
							права защищены 18+; Та ещё парочка © 2019 Flarsky Productions, LLC. All Rights Reserved 18+. Иллюзия обмана © 2013 SUMMIT ENTERTAINMENT. LLC. ALL RIGHTS RESERVED. 18+;
							Простая судьба © 2018 Lions Gate Films Inc. All Rights Reserved 18+
						</p>
					</div>
				</div>
			</div>
		</div>
	);
});
